import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { selectMembershipType, selectMembershipPackage } from '../../../../../Redux/Actions/EndUser/MembershipAction';
import { fetchAllMemberships, updateAdminMembership, addAdminMembership } from '../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { fetchMembershipTypes, fetchMembershipPackages } from '../../../../../Redux/Actions/EndUser/MembershipAction';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import { getCounties } from '../../../../../Redux/Actions/Admin/ManageDistrictActions';
import './ManageMembership.scss';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import _ from 'lodash';
import DateTimePicker from 'react-datetime-picker';

import PlacesAutocomplete, {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';

class MembershipForm extends Component {
	constructor(props) {
        super(props);
		this.state = {
            membershipInEdit: this.props.dataItem || null,
            countyList: [],
            value: []
		};
	}

	componentDidMount() {
        this.props.fetchMembershipTypes();
        if (this.state.membershipInEdit && this.state.membershipInEdit.membershipType && this.state.membershipInEdit.membershipType.membershipTypeID) {
            this.props.fetchMembershipPackages(this.state.membershipInEdit.membershipType.membershipTypeID);
        }
        this.props.fetchStates();
        

        if (this.state.membershipInEdit.state.id != 0) {
            this.props.getCounties(this.state.membershipInEdit.state.id);
        }
	}
    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleJoinDate = (date) => {
        const edited = this.state.membershipInEdit;
        edited.joinDate = date;
        this.setState({
            membershipInEdit: edited
        });
    };

    handleMembershipExpirationDate = (date) => {
        const edited = this.state.membershipInEdit;
        edited.membershipExpirationDate = date;
        this.setState({
            membershipInEdit: edited
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.membershipInEdit.membershipId) {
            this.props.save(this.state.membershipInEdit);
			this.props.cancel();
        }
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.membershipInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			membershipInEdit: edited
		});
    };
	handleMultiSelectChange = (event) => {
		var currentState = { ...this.state.membershipInEdit };
		currentState.permissions = [ ...event.target.value ];
		this.setState({
			membershipInEdit: currentState
		});
	};

    handleChange = (event) => {
        this.selectedMembershipType(event.target.value);
    }

    selectedMembershipType = (value) => {
        this.props.selectMembershipType(value);
        if (value !== null) {
            this.setState({ membershipInEdit: { ...this.state.membershipInEdit, membershipType: value, membershipPackage: {}, membershipPackageId: null} });
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    }

    handlePackageChange = (event) => {
        this.setState({ membershipInEdit: { ...this.state.membershipInEdit, membershipPackage: event.target.value, membershipPackageId: event.target.value.membershipPackageID} });
        this.props.selectMembershipPackage(event.target.value);
	}
    handleState = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

        this.props.getCounties(target.value.id);
		
        const edited = this.state.membershipInEdit;

        edited.state = value;
		if(name === "state")
		{
            edited.mailingStateId = value.id;
		}
		else if(name === "billingState")
		{
			edited.billingStateId = value.id;
        }
		this.setState({
            membershipInEdit: edited,
		});
    };

    handleStateChange = (event) => {
        const value = event.target.value;
        let newRecord = this.state.membershipInEdit;
        newRecord.state.id = value.id;
        newRecord.state.name = value.name;
        newRecord.mailingStateId = value.id;
        if (value !== null) {
            this.setState({ membershipInEdit: newRecord });
        }
    };

    handleCountyChange = (event) => {
        const value = event.target.value;
        let newRecord = this.state.membershipInEdit;
        newRecord.county.countyId = value.countyId;
        newRecord.county.countyName = value.countyName;

        if (value !== null) {
            this.setState({ membershipInEdit: newRecord });
        }
    };

    handleAutoAddressChange = address => {
        this.setState({ address });
    };

    handleAutoSelect = (address) => {
        //this.props.getCounties(this.state.state.id);
        //this.setState({ address });
        //this.setAutofillFields(address, this.props.district.counties);


        axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${this.state.membershipInEdit.state.id}`)
            .then((response) => {
                //this.props.setCounties(response.data);

                this.setState({
                    address,
                    countyList: response.data
                });
                this.setAutofillFields(address, response.data);
            })
            .catch((response) => {
                console.log(response);
            });
    };

    fetchCountiesByStateId = async (id) => {
        return await axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${id}`).then((response) => {
            this.setState({
                countyList: response.data
            });
        });
    }

    setCountyAsync = async (stateId, county) => {
        await this.fetchCountiesByStateId(stateId);

        var countyLst = this.state.countyList;
        var cpMembershipInEdit = this.state.membershipInEdit;

        countyLst.forEach(countyObj => {
            if (county.includes(countyObj.countyName)) {
                cpMembershipInEdit.county = countyObj;
                this.setState({
                    membershipInEdit: cpMembershipInEdit
                })
            }
        });
    }

    SetTopSuggestion = suggestions => {

        if (!_.isEqual(this.state.TopSuggestion, suggestions[0])) {
            this.setState({ TopSuggestion: suggestions[0] })
            this.setAutofillFields(suggestions[0].description);
        }
    }

    setAutofillFields = (address, countiesList) => {

        geocodeByAddress(address)
            .then(results => {

                results.map((addressResults) => {
                    var mailingInformation = {
                        ...this.state.membershipInEdit,
                        mailingAddress1: "",
                        mailingCity: "",
                        state: {
                            id: 0,
                            name: ''
                        },
                        county: { countyId: 0, countyName: "" },
                        mailingZip: ""
                    }
                    addressResults.address_components.map((result) => {
                        if (result.types.includes("street_number")) {
                            mailingInformation.mailingAddress1 = result["short_name"];
                        }
                        if (result.types.includes("route")) {
                            mailingInformation.mailingAddress1 = mailingInformation.mailingAddress1 + " " + result["short_name"];
                        }
                        if (result.types.includes("locality")) {
                            mailingInformation.mailingCity = result["short_name"];
                        }
                        if (result.types.includes("administrative_area_level_1")) {
                            //mailingInformation.state = result["short_name"];
                            var stateObj = this.props.common.states.find((stateObj) => {
                                if (stateObj.name === result["short_name"].toString()) {
                                    return stateObj
                                }
                            });

                            if (stateObj) {

                                mailingInformation.state = stateObj;

                            }

                        }
                        if (result.types.includes("administrative_area_level_2")) {
                            mailingInformation.county = result["long_name"];
                        }
                        if (result.types.includes("postal_code")) {
                            mailingInformation.mailingZip = result["short_name"];
                        }
                    });

                    //this.props.getCounties(mailingInformation.StateObject.id);
                    this.setState({ membershipInEdit: mailingInformation });

                })

            }).then(() => {
                //this.selectCounty(this.state.County);
                this.setCountyAsync(this.state.membershipInEdit.state.id, this.state.membershipInEdit.county);
            });
    }

	render() {
		return (
			<div className="popupMembershipForm">
				{!this.state.membershipInEdit.membershipId ? <h2>Add New Membership</h2> : <h2>Edit Membership</h2>}
				<form className="user-form membership-form" onSubmit={this.handleSubmit}>
                    {/* <div className="row"> */}

                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="membershipPackage">Membership Number</label>
                            {/* {console.log(this.props.membership, "this.props.membership")} */}
                            <Input
                                required={true}
                                type="text"
                                name="memberNumber"
                                value={this.state.membershipInEdit.memberNumber || ''}
                                onChange={this.onDialogInputChange}
                                id="memberNumber"
                                disabled={true}
                            />
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="joinDate">Join Date</label>
                            <DateTimePicker
                                disableClock={true}
                                format={"y-MM-dd"}
                                value={this.state.membershipInEdit.joinDate ? new Date(this.state.membershipInEdit.joinDate) : new Date()}
                                onChange={this.handleJoinDate}
                        />
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="membershipExpirationDate">Expiration Date</label>
                            <DateTimePicker
                                disableClock={true}
                                format={"y-MM-dd"}
                                required={true}
                                value={this.state.membershipInEdit.membershipExpirationDate ? new Date(this.state.membershipInEdit.membershipExpirationDate) : null}
                                onChange={this.handleMembershipExpirationDate}
                            />
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="membershipType">Membership Type</label>
                            <DropDownList data={this.props.membership.membershipTypes}
                                textField="description"
                                dataItemKey="membershipTypeID"
                                onChange={this.handleChange}
                                value={this.state.membershipInEdit.membershipType}
                                valid={(Object.keys(this.state.membershipInEdit.membershipType).length > 0 && this.state.membershipInEdit.membershipType.membershipTypeID > 0)}
                                allowCustom={false}
                                filterable={false}
                                clearButton={false}
                                width={300}
                                required={true}
                                name="membershipType"
                                id="membershipType"
                            />
                        </div>
                        <div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="membershipPackage">Membership Package</label>
                            {/* {console.log(this.props.membership, "this.props.membership")} */}
                            <DropDownList data={this.props.membership.membershipPackages}
                                textField="description"
                                dataItemKey="membershipPackageID"
                                onChange={this.handlePackageChange}
                                value={this.state.membershipInEdit.membershipPackage}
                                valid={(Object.keys(this.state.membershipInEdit.membershipPackage).length > 0 && this.state.membershipInEdit.membershipPackage.membershipPackageID > 0)}
                                allowCustom={false}
                                filterable={false}
                                clearButton={false}
                                width={300}
                                required={true}
                                name="membershipPackage"
                                id="membershipPackage"
                            />
                        </div>
                    {/* </div> */}
					<div className="membershipID form-group col-md-12">
                        <label htmlFor="organizationName" className="">Family/Group/Organization Name - what name would you like on your membership ID card and magazine?</label>
                        <Input
                            id="organizationName"
                            type="text"
                            value={this.state.membershipInEdit.organizationName}
                            onChange={this.onDialogInputChange}
                            name="organizationName"
                        />
                    </div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="firstName">First Name</label>
                        <Input
                            required={true}
                            type="text"
                            name="firstName"
                            value={this.state.membershipInEdit.firstName || ''}
                            onChange={this.onDialogInputChange}
                            id="firstName"
                        />
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="lastName">Last Name</label>
                        <Input
                            required={true}
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={this.state.membershipInEdit.lastName || ''}
                            onChange={this.onDialogInputChange}
                        />
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="email">Email</label>
                        <Input
                            required={true}
                            type="email"
                            name="email"
                            id="email"
                            value={this.state.membershipInEdit.email || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="referredBy" className="">Referred By</label>
                        <Input
                            id="referredBy"
                            type="text"
                            value={this.state.membershipInEdit.referredBy ? this.state.membershipInEdit.referredBy : ""}
                            onChange={this.onDialogInputChange}
                            name="referredBy"
                        />
                    </div>

                    <div className="form-group col-md-6 col-lg-4">
                        <h3 className="callout">Update <span className="highlight">Mailing Address</span></h3>
                    </div>
                    <label htmlFor="lookupAddrField">Lookup Address</label>
                    <PlacesAutocomplete
                        value={this.state.address || ""}
                        onChange={this.handleAutoAddressChange}
                        onSelect={this.handleAutoSelect}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div className="col-md-12" id="lookupAddrField" style={{ padding: '0px', paddingBottom: '10px' }}>
                                <input style={{ width: "100%" }}
                                    {...getInputProps({
                                        placeholder: 'Search Places...'
                                    })}
                                />
                                <div style={{ width: "100%" }}>
                                    {loading && <div><p>Loading...</p></div>}
                                    {suggestions.length > 0 ? this.SetTopSuggestion(suggestions)
                                        : ""}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? {
                                                backgroundColor: '#f0f0f0',
                                                cursor: 'pointer',
                                                width: '100%'
                                            }
                                            : {
                                                backgroundColor: '#ffffff',
                                                cursor: 'pointer',
                                                width: '100%'
                                            };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                    <div className="mailingAddressContainer">
                        <div className="address1-wrapper form-group col-md-6 col-lg-4">
                            <label htmlFor="address1">Address 1</label>
                            <Input
                                id="mailingAddress1"
                                type="text"
                                value={this.state.membershipInEdit.mailingAddress1}
                                onChange={this.onDialogInputChange}
                                name="mailingAddress1"
                            />
                        </div>
                        <div className="address2-wrapper form-group col-md-6 col-lg-4">
                            <label htmlFor="address2">Address 2</label>
                            <Input
                                id="mailingAddress2"
                                type="text"
                                value={this.state.membershipInEdit.mailingAddress2}
                                onChange={this.onDialogInputChange}
                                name="mailingAddress2"
                            />
                        </div>
                    </div>
                    <div className="cityStateZip">
                        <div className="city-wrapper form-group col-md-6 col-lg-4">
                            <label htmlFor="city">City</label>
                            <Input
                                id="mailingCity"
                                type="text"
                                value={this.state.membershipInEdit.mailingCity}
                                onChange={this.onDialogInputChange}
                                name="mailingCity"
                            />
                        </div>
                        <div className="state-wrapper form-group col-md-6 col-lg-2">
                            <label htmlFor="State">State</label>
                            <DropDownList data={this.props.common.states}
                                id="State"
                                name="state"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handleState}
                                value={this.state.membershipInEdit.state}
                            />
                        </div>
                        <div className="county-wrapper form-group col-md-6 col-lg-2">
                            <label htmlFor="County">County</label>
                            <DropDownList data={this.props.district.counties}
                                id="County"
                                name="County"
                                textField="countyName"
                                dataItemKey="countyId"
                                onChange={this.handleCountyChange}
                                value={this.state.membershipInEdit.county}
                                required={true}
                                valid={(Object.keys(this.state.membershipInEdit.county).length > 0 && this.state.membershipInEdit.county.countyId > 0)}
                            />
                        </div>
                        <div className="zip-wrapper form-group col-md-6 col-lg-2">
                            <label htmlFor="zip">Zip</label>
                            <Input
                                id="MailingZip"
                                validityStyles={false}
                                value={this.state.membershipInEdit.mailingZip}
                                onChange={this.onDialogInputChange}
                                name="mailingZip"
                                pattern="(\d{5}([\-]\d{4})?)"
                                type="text"
                                placeholder="12345"
                                title="Zip Code (Format: 12345 or 12345-6789)"
                            />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                            <label htmlFor="phone">Phone</label>
                            <Input
                                type="text"
                                name="phone"
                                id="phone"
                                value={this.state.membershipInEdit.phone || ''}
                                onChange={this.onDialogInputChange}
                            />
                        </div>
                    </div>
                    <div className="footer">
                        <div className="form-group">
                            <button className="admin-k-button cancel-btn" onClick={this.props.cancel}>
                                <i className="fas fa-times"></i>
								<span>CANCEL</span>
                            </button>
                            {!this.state.membershipInEdit.membershipID ? (
                                <button type="submit" className="admin-k-button">
                                    <i className="fas fa-save"></i>
									<span>SAVE</span>
                                </button>
                            ) : (
                                <button type="submit" className="admin-k-button">
                                    <i className="fas fa-edit"></i>
									<span>UPDATE</span>
                                </button>
                            )}
                        </div>
                    </div>
				</form>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		membership: state.membership,
        common: state.common,
        district: state.district
	};
}

export default connect(mapStateToProps, { fetchStates, fetchMembershipTypes, fetchMembershipPackages, selectMembershipType, selectMembershipPackage, addAdminMembership, updateAdminMembership, getCounties})(MembershipForm);